//
// Favorites collection
// --------------------

define(function(require, exports, module) {
    'use strict';

    var BaseCollection = require('common/base.collection');
    var server = require('server');
    var FavoritesModel = require('stores/favorites/favorites.model');

    module.exports = BaseCollection.extend({

        model: FavoritesModel,

        comparator: 'priority',

        parse: function(response) {
            return response.data.favoriteGames;
        },

        sync: function(method, model, options) {
            if (method === 'read') {
                return this._read(model, options);
            }
        },

        _read: function(model, options) {
            return server.send({
                ID: 31103,
                description: 'Get user favorites',
                responses: [31104, 31105],
                requestedFavorites: [ 'games' ],
                correlationId: 'string'
            })
                .done(options.success)
                .fail(options.error);
        }

    });
});
